import { normalizeMap } from '../lib'
import overlayDataProp from './overlayDataProp'

export default function (props) {
  const res = {}
  normalizeMap(props).forEach(({key, val}) => {
    res[key] = overlayDataProp(key, val)
  })
  return res
}



// WEBPACK FOOTER //
// ./src/utils/mapOverlayData.js